import { Button, ButtonGroup, IconButton } from '@chakra-ui/react';
import { MdAdd, MdRemove } from 'react-icons/md';
import { useSelector } from 'react-redux';

/*
 * Button group for the image viewer
 * This button group resets, and zooms for the image viewer
 */
const Buttons = ({ onSubtract, onReset, onAdd, text }) => {
    const { darkMode } = useSelector((state) => state.settings);
    const buttonStyles = {
        bg: darkMode ? '#121212' : '#E0E0E0',
        color: darkMode ? 'white' : 'black',
        borderRadius: '0.25rem',
        _hover: { bg: darkMode ? 'whiteAlpha.200' : 'gray.300' },
        _active: { bg: darkMode ? 'whiteAlpha.300' : 'gray.400' },
    };

    return (
        <ButtonGroup isAttached size="md" boxShadow="md">
            <IconButton
                aria-label="Zoom out"
                icon={<MdRemove size={24} />}
                onClick={onSubtract}
                {...buttonStyles}
            />
            <Button onClick={onReset} fontWeight="normal" {...buttonStyles}>
                {text}
            </Button>
            <IconButton
                aria-label="Zoom in"
                icon={<MdAdd size={24} />}
                onClick={onAdd}
                {...buttonStyles}
            />
        </ButtonGroup>
    );
};

export default Buttons;
